module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_6_Stearne.1aaab760fbfd3a2bf6a0c489a1b65b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_6_Stearne.png
// module id = 326
// module chunks = 0